"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _style = require("./style.sypes");

var color = { type: "color" };

var defaultProps = {
  componentName: "footer",
  cms: {
    style: {
      footerBgColor: "Background color",
      linkColor: "Link color",
      hoverColor: "Links hover color",
      fontSize: " Link font size",
      textTransform: "Text transform",
      fontWeight: "Font weight",
      // textAlign: "Text align",
      radius: "Icons shape",
      borderColor: "border color",
      iconColor: "Icons color",
      iconHoverColor: "Hover color",
      hoverBorderColor: "Hover border color"
    },
    content: {
      copyRight: "Copyright All right reserved",
      brandName: "brand name",
      column_1_title_1: "column_1_title_1",
      column_1_title_2: "column_1_title_2",
      column_1_title_3: "column_1_title_3",
      column_1_title_4: "column_1_title_4",
      column_2_title_1: "column_2_title_1",
      column_2_title_2: "column_2_title_2",
      column_2_title_3: "column_2_title_3",
      column_2_title_4: "column_2_title_4",
      column_3_title_1: "column_3_title_1",
      column_3_title_2: "column_3_title_2",
      column_3_title_3: "column_3_title_3",
      column_3_title_4: "column_3_title_4",
      facebookTitle: "facebookTitle",
      youTubeTitle: "youTubeTitle",
      twitterTitle: "twitterTitle",
      googleTitle: "googleTitle+"
    },
    media: {
      srcUrl: "Logo url",
      alt: "Image fallback text",
      facebookURL: "Facebook url",
      youTubeURL: "Youtube url",
      twitterURL: "Twitter url",
      googleURL: "Google url"
    }
  },
  styleType: {
    style: {
      footerBgColor: _extends({}, color),
      linkColor: _extends({}, color),
      hoverColor: _extends({}, color),
      fontSize: _extends({}, _style.fontSize),
      textTransform: _extends({}, _style.textTransform),
      fontWeight: _extends({}, _style.fontWeight),
      // textAlign: { ...textAlign },
      radius: _extends({}, _style.radius),
      borderColor: _extends({}, color),
      iconColor: _extends({}, color),
      iconHoverColor: _extends({}, color),
      hoverBorderColor: _extends({}, color)
    },
    content: {
      copyRight: "input",
      brandName: "input",
      column_1_title_1: "input",
      column_1_title_2: "input",
      column_1_title_3: "input",
      column_1_title_4: "input",
      column_2_title_1: "input",
      column_2_title_2: "input",
      column_2_title_3: "input",
      column_2_title_4: "input",
      column_3_title_1: "input",
      column_3_title_2: "input",
      column_3_title_3: "input",
      column_3_title_4: "input",
      facebookTitle: "input",
      youTubeTitle: "input",
      twitterTitle: "input",
      googleTitle: "input"
    },
    media: {
      srcUrl: "input",
      alt: "input",
      facebookURL: "input",
      youTubeURL: "input",
      twitterURL: "input",
      googleURL: "input"
    }
  },
  props: {
    //editable part
    style: {
      footerBgColor: "#36444f",
      // textAlign: "right",
      linkColor: "#fff",
      hoverColor: "red",
      fontSize: "16px",
      textTransform: "capitalize",
      borderColor: "#fff",
      fontWeight: "400",
      iconColor: "#fff",
      radius: "50%",
      hoverBorderColor: "#000",
      iconHoverColor: "#000"
    },
    content: {
      copyRight: "<p>Copyright All right reserved</p>",
      brandName: "<p>brand name</p>",
      column_1_title_1: "<p>Lorem Ipsum</p>",
      column_1_title_2: "<p>Lorem Ipsum</p>",
      column_1_title_3: "<p>Lorem Ipsum</p>",
      column_1_title_4: "<p>Lorem Ipsum</p>",
      column_2_title_1: "<p>Lorem Ipsum</p>",
      column_2_title_2: "<p>Lorem Ipsum</p>",
      column_2_title_3: "<p>Lorem Ipsum</p>",
      column_2_title_4: "<p>Lorem Ipsum</p>",
      column_3_title_1: "<p>Lorem Ipsum</p>",
      column_3_title_2: "<p>Lorem Ipsum</p>",
      column_3_title_3: "<p>Lorem Ipsum</p>",
      column_3_title_4: "<p>Lorem Ipsum</p>",
      facebookTitle: "<p>F</p>",
      youTubeTitle: "<p>Y</p>",
      twitterTitle: "<p>T</p>",
      googleTitle: "<p>G+</p>"
    },
    media: {
      srcUrl: "",
      alt: "test alt",
      facebookURL: "https://www.facebook.com/",
      youTubeURL: "https://www.youtube.com/",
      twitterURL: "https://twitter.com/",
      googleURL: "https://www.google.co.in/"
    }
  }
};

exports.default = defaultProps;